<div [ngClass]="getThemeClasses()">
  @if ((filterField.name?.length || 0) > 0) {
    <h3 class="page-title">{{ '' + filterField.name | translate }}</h3>
  }
  <mat-tab-group (selectedTabChange)="changeTab($event)" [selectedIndex]="selectedIndex">
    @if (useCustomCase) {
      @for (tab of filterField.options; track tab) {
        <mat-tab
          [label]="'' + (filterField.disableTranslation ? tab.name : (tab.name | translate))"
          />
      }
    } @else {
      @for (tab of filterField.options; track tab) {
        <mat-tab [label]="('' + tab.name).toUpperCase() | translate" />
      }
    }
  </mat-tab-group>
</div>
